import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import API from "@beardeddevops/react.api";

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
export default class CustomerCondensed extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Customers._name);
		this.redirect = this.props.baseUrl;
		this.state.validateAddress = null;
	}

	

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if (typeof this.props.searchChange === 'function') {
			if (this.state.name !== prevState.name && prevProps === this.props && this.state.name !== null) {
				this.props.searchChange(this.state.name);
			}
			if (this.state.phone !== prevState.phone && prevProps === this.props && this.state.phone !== null) {
				this.props.searchChange(this.state.phone);
			}
			if (this.state.alt_phone !== prevState.alt_phone && prevProps === this.props && this.state.alt_phone !== null) {
				this.props.searchChange(this.state.alt_phone);
			}
			if (this.state.email !== prevState.email && prevProps === this.props && this.state.email !== null) {
				this.props.searchChange(this.state.email);
			}
		}
	}

	loadSelfBefore = async (data) => {
		if (typeof this.props.onData === 'function') {
			this.props.onData(data);
		}

		return data;
	}

	async handleSubmit(event, suppressToast = false) {
		if ((!this.state.latitude || !this.state.longitude) && this.state.street_1) {
			this.setState({validateAddress: this.state.street_1})
		}
		//timeout is to assure that the address is validated
		setTimeout(async () => {
			if (this.state.validateAddress === 'validated' || !this.state.street_1) {
				await super.handleSubmit().then();
			} else {
				API.Toast.info('Unable to validate the address, please double check that everything is correct.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			}
		}, 500)
	}

	// noinspection JSUnusedLocalSymbols
	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @returns {Promise<void>}
	 */
	/*async afterSubmit(data) { HANDLED IN THE API NOW
		this.update = typeof this.props.id !== 'undefined' && this.props.id ? API.RequestType.UPDATE : API.RequestType.CREATE;
		console.log("are we doing this?");
		if (this.update === API.RequestType.CREATE) {

			if(process.env.production) {
				console.log("process");
				console.log(process.env.production);

				let myHeaders = new Headers();
				myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

				let urlencoded = new URLSearchParams();
				urlencoded.append("Name", data.name);
				urlencoded.append("Address", data.locations.street_1);
				urlencoded.append("City", data.locations.city);
				urlencoded.append("State", data.locations.state);
				urlencoded.append("Zip", data.locations.zip);
				urlencoded.append("Phone1", data.phone);
				urlencoded.append("Phone2", data.phone_alt ? data.phone_alt : '');
				urlencoded.append("Email", data.email);
				urlencoded.append("Referred", data.referer);
				urlencoded.append("Notes", data.notes);

				let requestOptions = {
					method: 'POST',
					headers: myHeaders,
					body: urlencoded,
					redirect: 'follow'
				};

				fetch("https://script.google.com/macros/s/AKfycbzWN4L8lG6k52kEIhQIAAQrfNWTIfRBzspfpCyreWaoxPeJgg4/exec", requestOptions)
					.then(response => response.text())
					.then(result => console.log(result))
					.catch(error => console.log('error', error));
			}
			else{

				// setup some local variables
				let $form = {
					name: data.name,
					address: data.locations.street_1,
					city: data.locations.city,
					state: data.locations.state,
					zip: data.locations.zip,
					phone1: data.phone,
					phone2: data.phone_alt,
					email: data.email,
					referer: data.referer,
					notes: data.notes,
					timestamp: Date.now()
				};

				console.log("here is the data: ");
				console.log(JSON.stringify($form));

				let myHeaders = new Headers();
				myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

				let urlencoded = new URLSearchParams();
				urlencoded.append("Name", data.name);
				urlencoded.append("Address", data.locations.street_1);
				urlencoded.append("City", data.locations.city);
				urlencoded.append("State", data.locations.state);
				urlencoded.append("Zip", data.locations.zip);
				urlencoded.append("Phone1", data.phone);
				urlencoded.append("Phone2", data.phone_alt ? data.phone_alt : '');
				urlencoded.append("Email", data.email);
				urlencoded.append("Referred", data.referer);
				urlencoded.append("Notes", data.notes);

				let requestOptions = {
					method: 'POST',
					headers: myHeaders,
					body: urlencoded,
					redirect: 'follow'
				};

				fetch("https://script.google.com/macros/s/AKfycbx0pB7ezO0qMAsSKZChx81g0RuHELWwMu4kBOvM-CfNmfeFfQc/exec", requestOptions)
					.then(response => response.text())
					.then(result => console.log(result))
					.catch(error => console.log('error', error));

			}


		}
	}*/

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Customers_Object} data
	 */
	loadSelfAfter(data) {
		if (typeof this.props.loadLocations === 'function') {
			this.props.loadLocations({
				locations: data.customers_locationss
			});
		}
	};

	//Note: Doesn't need a form() function. Only ever used in a modal
	form = () => {
		/**
		 * @param {Customers_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Customers_Object} object
		 */
		let object = this.state
		let {loading} = this.state


		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col"}>
							<h4 className="section-title">Contact Information</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Name'}
								/>
							</div>

							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone}
											value={object.phone}
											error={object.phone_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone_alt}
											value={object.phone_alt}
											error={object.phone_alt_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Alternate Phone'}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{!object.pkey && <div className={"form-group"}>{
								//TODO REPLACE BELOW WITH CUSTOMER LOCATION AND REWORK SAVING NEW CUST
							}
								<div>
									<Parts.AddressLong findFE={this.props.findFE} history={this.props.history} object={{...this.state}}
									                        properties={properties} parent={this}
									                        searchChange={typeof this.props.searchChange === 'function' ? this.props.searchChange : null}
									                        validateAddress={this.state.validateAddress}/>
								</div>
							</div>}
							<div>
								<div className="form-group">
									<div>
										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.referer}
												value={object.referer}
												error={object.referer_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<Framework.Elements.TextField
										property={properties.notes}
										value={object.notes}
										error={object.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										multiline={4}
									/>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
